<template>
  <a-modal
    title="员工资料转移"
    v-model="visible"
    :confirmLoading="loading"
    :destroyOnClose="true"
    @ok="save"
  >
    <a-form :form="form">
      <a-form-item label="员工" v-bind="formItemLayout">
        <a-auto-complete
          :dataSource="dataSource"
          @select="onSelect"
          @search="handleSearch"
          v-decorator="[
            'uid',
            { rules: [{ required: true, message: '请填写员工邮箱或者手机号' }] }
          ]"
          placeholder="请填写员工邮箱或者手机号"
        />
      </a-form-item>
    </a-form>
    <a-alert message="该操作将将转移员工账户下所有资料，请谨慎操作，该操作不可逆" :showIcon="false" type="error" />
  </a-modal>
</template>
<script>
import Api from "@/api";
import debounce from "lodash/debounce";
export default {
  name: "transformStaffModal",
  data() {
    this.handleSearch = debounce(this.handleSearch, 800);
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18 }
      },
      record: {},
      loading: false,
      visible: false,
      dataSource: [],
      uid: ""
    };
  },
  methods: {
    save() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!this.uid) {
            this.form.setFields({
              uid: {
                value: "",
                errors: [{ message: "请确认员工信息" }]
              }
            });
            return;
          }
          this.loading = true;
          try {
            await Api.account.tranfromUserInfo({
              from_user_id: this.record.uid,
              to_user_id: values.uid
            });
            this.close();
            this.$emit("ok");
          } catch (e) {}
          this.loading = false;
        }
      });
    },
    show(record) {
      this.visible = true;
      this.record = record;
    },
    close() {
      this.visible = false;
    },
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({ name: value });
      let arr = [];
      response.forEach(item => {
        arr.push({ value: item.uid, text: item.name });
      });
      this.dataSource = arr;
    },
    onSelect(value) {
      this.uid = value;
    }
  }
};
</script>

<style scoped lang="scss"></style>
